export default "__VITE_ASSET__82fb421e__"